import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CifrasMensualesService {

    constructor(private http: HttpClient) { }

    getCifrasMensuales() {
        return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Figureformonth");
    }

    
    getCifraAcumulada() {
      return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Figureformonth/totaldelmes");
  }


    
}